export enum WindowType {
  ADD_MEMBER,
  HISTORY,
  RIGHTS,
  MFA,
  PASSWORD,
  WARNING,
  FORM,
  IMAGE,
  DownloadCertificate,
  VIDEO,
  POST_JOURNAL,
  EXCEL_TRANSACTIONS,
}

export enum DrawerType {
  CONNECT_ENTITY,
  ADD_TAX_RETURN,
  ADD_TAX_SUBMISSION,
  ADD_MEMBER,
  LOAD_FROM_OTHER_ENTITY,
  LOAD_DEFAULT_MAPPINGS,
  HISTORY,
  RIGHTS,
  EDIT,
  CHANGE_OWNER,
  EDIT_FRIENDLY_NAME,
  INVITE_USER,
  NOT_APPROVED_FORM,
  ACTIVITY_LOGS,
  VIES_LOGS,
  MFA,
  CONNECT_CIN7,
  ADJUSTMENT_FORM,
  EDIT_PLAN,
  ADD_NEW_TAXES,
  ADD_CHART_OF_ACCOUNTS,
  CREATE_TAX_TEMPLATE,
  CUSTOMIZE_DASHBOARD_CARDS,
  BOARD_STATUS_SETTINGS,
  CUSTOMIZE_COLUMNS,
  FILTER_VIEWS_SETTINGS,
  FILTER_SELECTION,
  RECONCILIATION,
  UPLOAD_TRANSACTIONS,
  CREATE_GROUP,
  DRIVE_UPLOAD_LOGS,
  CAPTURE_STATISTICS,
  INTERPRETATION_RULES,
  SCANNING_PREFERENCES,
}

export enum VatTaxReportType {
  VAT_RETURN = 'VAT_RETURN',
  RECAP = 'RECAP',
  CASH_ACCOUNTING = 'CASH_ACCOUNTING',
}

export enum DataLogStatus {
  SAVED = 'Saved',
  LOCKED = 'Locked',
  SUBMITTED = 'Submitted',
  CANCELLED = 'Cancelled',
  AWAITING_APPROVAL = 'Awaiting Approval',
  INTERNAL_APPROVED = 'Internal Approved',
  APPROVED = 'Approved',
  AWAITING_CLIENT_APPROVAL = 'Awaiting Client',
  CLIENT_APPROVED = 'Client Approved',
  NOT_SAVED = 'Not Saved',
  EXCEPTIONS_MODIFIED = 'Exceptions Modified',
  NOT_STARTED = 'Not Started',
}

export enum DataLogActions {
  REVERT_DATA = 'Revert data',
  SAVE_VAT_RETURN = 'Save Submission',
  CANCEL_RETURN = 'Cancel return',
  LOCK_AS_APPROVED = 'Lock as approved',
  SET_AWAITING_APPROVAL = 'Set as awaiting approval',
  SET_INTERNAL_APPROVED = 'Set as internal approved',
  SET_NOT_APPROVED = 'Set not approved',
  SEND_FOR_CLIENT_APPROVAL = 'Send for client approval',
  SET_CLIENT_APPROVED = 'Set as client approved',
  MARK_AS_SUBMITTED = 'Mark as submitted with authorities',
}

export enum ViesStatus {
  VALID = 'Valid',
  INVALID = 'Invalid',
  ERROR = 'Error',
  EMPTY = 'Missing',
  MISSING = 'Missing',
  SYSTEM_UNAVAILABLE = 'System Unavailable',
}

export enum TaxReportCountry {
  MALTA = 'Malta',
  CYPRUS = 'Cyprus',
  UAE = 'UAE',
  IRELAND_DETAILED = 'IrelandDetailed',
  IRELAND_STANDARD = 'IrelandStandard',
  IRELAND_RECAP = 'IrelandRecap',
  IRELAND_RTD = 'IrelandRTD',
  ISLE_OF_MAN = 'IsleOfMan',
  JERSEY = 'Jersey',
  NETHERLANDS = 'Netherlands',
  UK = 'United Kingdom',
  SOUTH_AFRICA = 'South Africa',
  EUROPE = 'Europe',
}

export enum ActivityRoles {
  PREPARER = 'preparer',
  REVIEWER = 'reviewer',
  CLIENT = 'client',
  REMOVE_REVIEWER = 'remove-reviewer',
  REMOVE_CLIENT = 'remove-client',
}

export enum ActivityType {
  SAVED = 'Saved',
  LOCKED = 'Locked',
  SUBMITTED = 'Submitted',
  NOTE = 'Note',
  REFRESHED = 'Refreshed',
  CANCELLED = 'Cancelled',
  PREPARER = 'Preparer',
  REVIEWER = 'Reviewer',
  CLIENT = 'Client',
  AWAITING_APPROVAL = 'Awaiting Approval',
  INTERNAL_APPROVED = 'Internal Approval',
  INTERNAL_NOT_APPROVED = 'Internal Not Approved',
  AWAITING_CLIENT_APPROVAL = 'Awaiting Client Approval',
  CLIENT_NOT_APPROVED = 'Client Not Approved',
  CLIENT_APPROVED = 'Client Approved',
  DEFERRED_EXCEPTIONS = 'Deferred Exceptions',
  EXCEPTIONS_RESOLVED = 'Exceptions Resolved',
  SUBMITTED_PERIOD_ADJUSTED = 'Submitted Period Adjusted',
  OUT_OF_SYSTEM_ADJUSTED = 'Out of System Adjusted',
  REMINDER = 'Reminder',
  CLIENT_REMOVED = 'Client Removed',
  REVIEWER_REMOVED = 'Reviewer Removed',
  PERIOD_ADJUSTED = 'Period Adjusted',
  FILE_UPLOAD = 'File Upload',
  FILE_DELETE = 'File Delete',
  ROW_EDIT = 'Row Edit',
  ROW_DELETE = 'Row Delete',
}

export enum MenuSize {
  NARROW = 'narrow',
  WIDE = 'wide',
}

export enum Pages {
  DASHBOARD = 'Dashboard',
  ENTITIES = 'Entities',
  PLANNER = 'Planner',
  RETURNS = 'Returns',
  REPORTING = 'Reporting',
  BILLING = 'Billing',
  VIES = 'VAT Number Checker',
  USERS = 'Users',
  SUPPORT = 'Support',
  WHATS_NEW = "What's New",
  PROFILE = 'Profile',
  RETURN = 'Return',
  SUBMISSION = 'Submission',
  REVIEW = 'Review Submission',
  PRICING = 'Pricing',
  ACCESSIBILITY = 'Accessibility',
}

export enum dashboardStatistic {
  taxReturns = 'tax-returns',
  dueReturns = 'due-returns',
  expiredReturns = 'expired-returns',
  awaitingClient = 'awaiting-client',
}

export enum VIESContactStatistic {
  Customers = 'customers',
  Suppliers = 'suppliers',
  ContactsErrors = 'contacts-errors',
  StatusMissing = 'status-missing',
}

export enum CurrentModal {
  NONE,
  HISTORY,
  RIGHTS,
  EDIT,
}

export enum SubmissionUpdateField {
  STATUS,
  PREPARER,
  REVIEWER,
  CLIENT,
  REMOVE_CLIENT,
  REMOVE_REVIEWER,
}

export enum ContactType {
  SUPPLIER = 'Supplier',
  CUSTOMER = 'Customer',
  BOTH = 'Both',
  NULL = 'None',
}

export enum ViesTriggerType {
  WEBHOOK = 'Auto-log from',
  CONTACT_REFRESH = 'Auto-log',
  //ALL_CONTACTS_REFRESH = 'All contacts refresh',
  CONTACT_CREATE = 'New record',
  SINGLE_CONTACT_VALIDATION = 'Manual refresh',
  ALL_CONTACTS_VALIDATION = 'Manual refresh',
  TAX_GENERATION = 'System generated refresh',
}

export enum TaxRateType {
  INPUT = 'INPUT',
  OUTPUT = 'OUTPUT',
}

export enum TaxRateStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  ARCHIVED = 'ARCHIVED',
}

export enum PaymentMethod {
  VISA = 'VISA',
  MASTERCARD = 'MASTERCARD',
  AMEX = 'AMEX',
  DINERS = 'DINERS',
  DISCOVER = 'DISCOVER',
  JCB = 'JCB',
  UNIONPAY = 'UNIONPAY',
  MAESTRO = 'MAESTRO',
  VISA_DEBIT = 'VISA_DEBIT',
  MASTERCARD_DEBIT = 'MASTERCARD_DEBIT',
}

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED',
  PENDING = 'PENDING',
}

export enum AccountType {
  BANK = 'BANK',
  CURRENT = 'CURRENT',
  CURRLIAB = 'CURRLIAB',
  DEPRECIATN = 'DEPRECIATN',
  DIRECTCOSTS = 'DIRECTCOSTS',
  EQUITY = 'EQUITY',
  EXPENSE = 'EXPENSE',
  FIXED = 'FIXED',
  INVENTORY = 'INVENTORY',
  LIABILITY = 'LIABILITY',
  NONCURRENT = 'NONCURRENT',
  OTHERINCOME = 'OTHERINCOME',
  OVERHEADS = 'OVERHEADS',
  PREPAYMENT = 'PREPAYMENT',
  REVENUE = 'REVENUE',
  SALES = 'SALES',
  TERMLIAB = 'TERMLIAB',
  PAYGLIABILITY = 'PAYGLIABILITY',
  SUPERANNUATIONEXPENSE = 'SUPERANNUATIONEXPENSE',
  SUPERANNUATIONLIABILITY = 'SUPERANNUATIONLIABILITY',
  WAGESEXPENSE = 'WAGESEXPENSE',
}

export enum FilterAccounTypes {
  BANK = 'Bank',
  CURRENT = 'Current Asset',
  CURRLIAB = 'Current Liability',
  DEPRECIATN = 'Depreciation',
  DIRECTCOSTS = 'Direct Costs',
  EQUITY = 'Equity',
  EXPENSE = 'Expense',
  // Excel-specific aliases
  EXPENSES = 'Expenses',
  FIXED = 'Fixed Asset',
  INVENTORY = 'Inventory Asset',
  LIABILITY = 'Liability',
  NONCURRENT = 'Non-current Asset',
  OTHERINCOME = 'Other Income',
  OVERHEADS = 'Overhead',
  PREPAYMENT = 'Prepayment',
  REVENUE = 'Revenue',
  SALES = 'Sale',
  TERMLIAB = 'Non-current Liability',
  OTHER_CURRENT_ASSET = 'Other Current Asset',
  FIXED_ASSET = 'Fixed Asset',
  OTHER_ASSET = 'Other Asset',
  OTHER_EXPENSE = 'Other Expense',
  COST_OF_GOODS_SOLD = 'Cost of Goods Sold',
  COST_OF_SALES = 'Cost of sales',
  ACCOUNTS_PAYABLE = 'Accounts Payable',
  ACCOUNTS_RECEIVABLE = 'Accounts Receivable',
  CREDIT_CARD = 'Credit Card',
  NON_POSTING = 'Non-Posting',
  LONG_TERM_LIABILITY = 'Long Term Liability',
  OTHER_CURRENT_LIABILITY = 'Other Current Liability',
  INCOME = 'Income',
  DEPRECIATION = 'Depreciation',
  OTHER_INCOME = 'Other Income',
  //zoho
  other_asset = 'Other Asset',
  other_current_asset = 'Other Current Asset',
  intangible_asset = 'Intangible Asset',
  right_to_use_asset = 'Right To Use Asset',
  financial_asset = 'Financial Asset',
  contingent_asset = 'Contingent Asset',
  contract_asset = 'Contract Asset',
  cash = 'Cash',
  bank = 'Bank',
  stock = 'Stock',
  fixed_asset = 'Fixed Asset',
  other_current_liability = 'Other Current Liability',
  contract_liability = 'Contract Liability',
  refund_liability = 'Refund Liability',
  credit_card = 'Credit Card',
  long_term_liability = 'Long Term Liability',
  loans_and_borrowing = 'Loans And Borrowing',
  lease_liability = 'Lease Liability',
  employee_benefit_liability = 'Employee Benefit Liability',
  contingent_liability = 'Contingent Liability',
  financial_liability = 'Financial Liability',
  other_liability = 'Other Liability',
  equity = 'Equity',
  income = 'Income',
  finance_income = 'Finance Income',
  other_comprehensive_income = 'Other Comprehensive Income',
  other_income = 'Other Income',
  expense = 'Expense',
  manufacturing_expense = 'Manufacturing Expense',
  impairment_expense = 'Impairment Expense',
  depreciation_expense = 'Depreciation Expense',
  employee_benefit_expense = 'Employee Benefit Expense',
  lease_expense = 'Lease Expense',
  finance_expense = 'Finance Expense',
  tax_expense = 'Tax Expense',
  cost_of_goods_sold = 'Cost Of Goods Sold',
  other_expense = 'Other Expense',
  accounts_receivable = 'Accounts Receivable',
  accounts_payable = 'Accounts Payable',
}
export enum LicenseType {
  BLOCKED = 'blocked',
  TRIAL = 'trial',
  PAID = 'paid',
}

export enum LicenseStatus {
  UNLIMITED = 'unlimited',
  ACTIVE = 'active',
}

export enum UploadTransactionsSelection {
  BLANK = 'BLANK',
  GEN_TAX = 'GEN_TAX',
  SAGE = 'SAGE',
}

export enum ThirdPartySSO {
  ZOHO = 'zoho',
}

export enum AdvancedUserRightsCodes {
  CANCEL_SUBMISSION = 'CANCEL_SUBMISSION',
  CREATE_EDIT_RETURN = 'CREATE_EDIT_RETURN',
  VAT_NUMBER_CHECKER = 'VAT_NUMBER_CHECKER',
  CREATE_SUBMISSION = 'CREATE_SUBMISSION',
  CREATE_TAX_RATES = 'CREATE_TAX_RATES',
  APPROVE_SUBMISSION = 'APPROVE_SUBMISSION',
  GENERATE_RECONCILIATION = 'GENERATE_RECONCILIATION',
}

export enum EntityStatus {
  DELETED = 'DELETED',
  VIEW_ONLY = 'VIEW_ONLY',
  ACTIVE = 'ACTIVE',
}

/** Provider subscription/plan tier (e.g. Xero LEDGER). */
export enum ProviderPlan {
  LEDGER = 'LEDGER',
}

export enum ExcelTransactionSourceType {
  BILL = 'Bill',
  CREDIT_NOTE = 'Credit Note',
  INVOICE_PAYABLE = 'Invoice Payable',
  ACCOUNTS_PAYABLE = 'Accounts Payable',
  BALANCE_SHEET_LEDGER = 'Balance Sheet / Ledger',
  PURCHASE_INVOICE = 'Purchase Invoice',
  DAILY_OPERATIONS = 'Daily Operations',
  CREDIT_MEMO = 'Credit Memo',
  GENERAL_RETURNS = 'General Returns',
  SUPPLIER_CREDIT_NOTE = 'Supplier Credit Note',
  VENDOR_CREDIT = 'Vendor Credit',
  SOFTWARE_AP_PROCESSING = 'Software / AP Processing',
}

export enum ExcelTransactionAccountType {
  INCOME = 'Income',
  EXPENSES = 'Expenses',
  COST_OF_SALES = 'Cost of sales',
  DEPRECIATION = 'Depreciation',
}

/**
 * Chart of accounts type shown in the UI.
 * Keys match the API (`ACCOUNTS_RECEIVABLE`, Xero `CURRLIAB`, …). Values are the labels.
 */
export enum ChartOfAccountType {
  ACCOUNTS_RECEIVABLE = 'Accounts Receivable',
  ACCOUNTS_PAYABLE = 'Accounts Payable',
  BANK = 'Bank',
  CURRENT = 'Current Asset',
  OTHER_CURRENT_ASSET = 'Other Current Asset',
  FIXED = 'Fixed Asset',
  FIXED_ASSET = 'Fixed Asset',
  INVENTORY = 'Inventory Asset',
  stock = 'Stock',
  NONCURRENT = 'Non-current Asset',
  OTHER_ASSET = 'Other Asset',
  PREPAYMENT = 'Prepayment',
  CURRLIAB = 'Current Liability',
  OTHER_CURRENT_LIABILITY = 'Other Current Liability',
  LIABILITY = 'Liability',
  TERMLIAB = 'Non-current Liability',
  LONG_TERM_LIABILITY = 'Long Term Liability',
  CREDIT_CARD = 'Credit Card',
  EQUITY = 'Equity',
  INCOME = 'Income',
  OTHERINCOME = 'Other Income',
  OTHER_INCOME = 'Other Income',
  REVENUE = 'Revenue',
  SALES = 'Sale',
  EXPENSE = 'Expense',
  EXPENSES = 'Expenses',
  OTHER_EXPENSE = 'Other Expense',
  DIRECTCOSTS = 'Direct Costs',
  OVERHEADS = 'Overhead',
  COST_OF_SALES = 'Cost of sales',
  COST_OF_GOODS_SOLD = 'Cost of Goods Sold',
  DEPRECIATN = 'Depreciation',
  DEPRECIATION = 'Depreciation',
  NON_POSTING = 'Non-Posting',
  PAYGLIABILITY = 'Payroll Liability',
  SUPERANNUATIONEXPENSE = 'Superannuation Expense',
  SUPERANNUATIONLIABILITY = 'Superannuation Liability',
  WAGESEXPENSE = 'Wages Expense',
}
